import { Artstamm } from './artstamm';

export interface Material {
  id: number;
  artstamm: Item | Artstamm;
  menge?: number;
  preis?: number;
  gewicht?: number;
  buchgewicht?: number;
  legierung?: string;
}

export interface ArtstammMaterial extends Material {
  artstamm: Artstamm;
}

export interface ItemMaterial extends Material {
  artstamm: Item
}

export interface Item {
  id: number;
  cartikelnummer: string;
  artbez1: string;
  artbez2?: string;
  artbez3?: string;
}